module.exports = __webpack_public_path__ + "static/img/img-4-3.0acba16.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-3.png
// module id = Qa99
// module chunks = 0